import { isWithinMonths, toJsDate } from '../dateWindow';

import type { SignalContext, SignalOutcome } from '../types';

export const PREFORECLOSURE_LOOKBACK_MONTHS = 24;
export const BANKRUPTCY_LOOKBACK_MONTHS = 24;
export const FAILED_LISTING_LOOKBACK_MONTHS = 18;
export const RECENTLY_MOVED_LOOKBACK_MONTHS = 12;
export const FAMILY_TRANSFER_LOOKBACK_MONTHS = 36;
export const LONG_TENURE_MIN_YEARS = 10;
export const FAMILY_TRANSFER_MAX_VALUE = 100;
export const HIGH_EQUITY_MAX_ALTV = 50;

export const RESOLVED_CIVIL_STATUSES = new Set([
  'closed',
  'dismissed',
  'released',
  'satisfied',
  'settled',
  'vacated',
]);

export const fired = (evidence?: string): SignalOutcome => ({
  status: 'fired',
  evidence,
});
export const notFired = (evidence?: string): SignalOutcome => ({
  status: 'not_fired',
  evidence,
});
export const unavailable = (reason: string): SignalOutcome => ({
  status: 'unavailable',
  reason,
});

export const mostRecentDeed = (ctx: SignalContext) => {
  const deeds = ctx.subjectProperty.deeds ?? [];
  return [...deeds]
    .filter((deed) => deed.transfer)
    .sort(
      (a, b) =>
        (toJsDate(b.transfer?.filing_date)?.getTime() ?? 0) -
        (toJsDate(a.transfer?.filing_date)?.getTime() ?? 0)
    )[0];
};

export const isFamilyTransfer = (
  deed: ReturnType<typeof mostRecentDeed>,
  now: Date
): boolean => {
  const transfer = deed?.transfer;
  if (!transfer) {
    return false;
  }

  const transferValue = transfer.transfer_value;
  if (transferValue == null || transferValue > FAMILY_TRANSFER_MAX_VALUE) {
    return false;
  }

  const buyerLastNames = (transfer.buyers ?? [])
    .map((buyer) => buyer.name?.parsed?.last?.toLowerCase())
    .filter(Boolean);
  const sellerLastNames = (transfer.sellers ?? [])
    .map((seller) => seller.name?.parsed?.last?.toLowerCase())
    .filter(Boolean);
  const sharesLastName = buyerLastNames.some((last) =>
    sellerLastNames.includes(last)
  );

  return (
    sharesLastName &&
    isWithinMonths(transfer.filing_date, FAMILY_TRANSFER_LOOKBACK_MONTHS, now)
  );
};
